module.exports = __webpack_public_path__ + "img/inventory.a83da305.svg";